import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import logoMenu from "../static/media/logoGRMPNG.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  tealDark: "#38B29A",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const SECTIONS = [
  { path: "/", label: "Inicio" },
  { path: "/productos", label: "Productos" },
  { path: "/tienda", label: "Tienda" },
  { path: "/nosotros", label: "Nosotros" },
  { path: "/contacto", label: "Contacto" },
];

const PHONE_DISPLAY = "+593 98 772 4998";
const PHONE_TEL = "+593987724998";
const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=593987724998&text=Hola+quiero+m%C3%A1s+informaci%C3%B3n&type=phone_number&app_absent=0";
const INSTAGRAM_URL = "https://www.instagram.com/electrica_grm/";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100078693296652";
const DEVZONE_URL = "https://devzone-ec.com/";
const PRINDELA_URL = "https://www.prindela.com/";

function SocialButton({ href, label, children }) {
  return (
    <Box
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: `1.5px solid rgba(255,205,0,0.35)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: C.gold,
        background: "rgba(255,205,0,0.06)",
        transition: "all .22s",
        flexShrink: 0,
        "&:hover": {
          background: C.gold,
          color: C.dark,
          borderColor: C.gold,
          transform: "translateY(-2px)",
        },
      }}
    >
      {children}
    </Box>
  );
}

function FooterHeading({ children }) {
  return (
    <Typography
      sx={{
        color: C.gold,
        fontWeight: 800,
        fontSize: "11px",
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        mb: "16px",
      }}
    >
      {children}
    </Typography>
  );
}

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        background: `linear-gradient(180deg, ${C.dark} 0%, #050d14 100%)`,
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      {/* Barra tricolor */}
      <Box
        sx={{
          height: "3px",
          background: `linear-gradient(90deg, ${C.navy} 0%, ${C.gold} 55%, ${C.teal} 100%)`,
        }}
      />

      <Box
        sx={{
          maxWidth: "1140px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "28px" },
          pt: { xs: 6, md: 7 },
          pb: { xs: 4, md: 5 },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "1.4fr 1fr 1.2fr",
            },
            gap: { xs: "40px", sm: "32px", md: "32px" },
          }}
        >
          {/* Columna marca */}
          <Box>
            <Box
              onClick={() => handleNavigation("/")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "11px",
                cursor: "pointer",
                mb: "16px",
                width: "fit-content",
              }}
            >
              <Box
                sx={{
                  width: 46,
                  height: 46,
                  borderRadius: "50%",
                  border: `2.5px solid ${C.gold}`,
                  background: "rgba(255,255,255,0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: `0 0 0 5px rgba(255,205,0,0.09)`,
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={logoMenu}
                  alt="Eléctrica GRM"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                  sx={{
                    width: 36,
                    height: 36,
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}
              >
                <Typography
                  sx={{
                    color: C.white,
                    fontWeight: 800,
                    fontSize: "17px",
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                    lineHeight: 1,
                  }}
                >
                  Eléctrica
                </Typography>
                <Typography
                  sx={{
                    color: C.gold,
                    fontWeight: 800,
                    fontSize: "10px",
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    mt: "2px",
                  }}
                >
                  GRM
                </Typography>
              </Box>
            </Box>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.60)",
                fontSize: "13.5px",
                lineHeight: 1.7,
                maxWidth: 300,
                mb: "20px",
              }}
            >
              Material eléctrico, herramientas e iluminación con garantía y
              soporte directo de fábrica.
            </Typography>

            <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <SocialButton href={INSTAGRAM_URL} label="Instagram">
                <InstagramIcon sx={{ fontSize: 18 }} />
              </SocialButton>
              <SocialButton href={FACEBOOK_URL} label="Facebook">
                <FacebookIcon sx={{ fontSize: 18 }} />
              </SocialButton>
              <SocialButton href={WHATSAPP_URL} label="WhatsApp">
                <WhatsAppIcon sx={{ fontSize: 18 }} />
              </SocialButton>
            </Box>
          </Box>

          {/* Columna navegación */}
          <Box>
            <FooterHeading>Navegación</FooterHeading>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {SECTIONS.map((s) => (
                <Typography
                  key={s.path}
                  component="button"
                  onClick={() => handleNavigation(s.path)}
                  sx={{
                    all: "unset",
                    display: "block",
                    cursor: "pointer",
                    color: "rgba(255,255,255,0.75) !important",
                    fontSize: "13.5px",
                    fontWeight: 600,
                    transition: "color .2s, transform .15s",
                    "&:hover": {
                      color: `${C.teal} !important`,
                      transform: "translateX(3px)",
                    },
                  }}
                >
                  {s.label}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* Columna contacto */}
          <Box>
            <FooterHeading>Contacto</FooterHeading>

            <Box
              component="a"
              href={`tel:${PHONE_TEL}`}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                textDecoration: "none",
                color: "rgba(255,255,255,0.75)",
                fontSize: "13.5px",
                fontWeight: 600,
                mb: "14px",
                transition: "color .2s",
                "&:hover": { color: C.teal },
              }}
            >
              <PhoneIcon sx={{ fontSize: 16, color: C.gold, flexShrink: 0 }} />
              {PHONE_DISPLAY}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "rgba(255,255,255,0.60)",
                fontSize: "13.5px",
                mb: "22px",
              }}
            >
              <LocationOnIcon
                sx={{ fontSize: 16, color: C.gold, flexShrink: 0 }}
              />
              Quito, Ecuador
            </Box>

            <Box
              component="a"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                background: C.gold,
                color: C.dark,
                fontWeight: 800,
                fontSize: "13px",
                px: "20px",
                py: "10px",
                borderRadius: "50px",
                transition: "background .2s, transform .15s",
                "&:hover": {
                  background: C.goldDark,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <WhatsAppIcon sx={{ fontSize: 16 }} />
              Escríbenos
            </Box>
          </Box>
        </Box>

        {/* Separador */}
        <Box
          sx={{
            height: "1px",
            background: `linear-gradient(90deg, rgba(255,205,0,0.30), rgba(255,205,0,0.02))`,
            my: { xs: 4, md: 5 },
          }}
        />

        {/* Barra inferior */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: "10px",
          }}
        >
          <Typography
            sx={{
              color: "rgba(255,255,255,0.40)",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            © 2026 ELÉCTRICA GRM — Ecuador, Quito
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.40)",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            Desarrollado por{" "}
            <Box
              component="a"
              href={DEVZONE_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: C.gold,
                fontWeight: 700,
                textDecoration: "none",
                "&:hover": { color: C.teal },
              }}
            >
              DevZone
            </Box>{" "}
            &{" "}
            <Box
              component="a"
              href={PRINDELA_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: C.gold,
                fontWeight: 700,
                textDecoration: "none",
                "&:hover": { color: C.teal },
              }}
            >
              Prindela Service
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
